export default __webpack_public_path__ + "assets/img_boat-64b7de8a.png";